import { render, staticRenderFns } from "./InheritanceIcon.vue?vue&type=template&id=5f9f9cf0&"
import script from "./InheritanceIcon.vue?vue&type=script&lang=js&"
export * from "./InheritanceIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports